var path = 'app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/chart/metricAlarmChart.component.html';
var html = "<div class=\"no-data-overlay\" ng-if=\"$ctrl.chartData.loading || $ctrl.chartData.noData\">\n  <h5 class=\"text-center\">\n    <span ng-if=\"$ctrl.chartData.noData\">No data available</span>\n    <span ng-if=\"$ctrl.chartData.loading\">\n      <loading-spinner size=\"'medium'\"></loading-spinner>\n    </span>\n  </h5>\n</div>\n<linechart ng-class=\"$ctrl.chartData.noData ? 'no-data' : ''\"\n           data=\"$ctrl.chartData\"\n           options=\"$ctrl.chartOptions\"></linechart>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/chart/metricAlarmChart.component.html
// module id = 1181
// module chunks = 0